
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground } from 'docz'
import { types } from 'mobx-state-tree'
import Character from '@/models/Character'
import Item from '@/components/Item'

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h2" components={components} props={{"id":"item-component"}}>{`Item Component`}</MDXTag>
<Playground __position={0} __code={'() => {\n  const character = Character.create({\n    attributes: [{ name: \'Strength\' }, { name: \'Charisma\' }],\n    items: [\n      {\n        name: \'Greatsword of Maiming\',\n        description: \'The family sword of House Ednyzil.\',\n        effects: [\n          { modifier: 2, modifies: \'Strength\' },\n          { modifier: 4, modifies: \'Charisma\' },\n          { modifier: 2, modifies: \'Charisma\', condition: \'in Ft. Ednyzil\' },\n        ],\n        equipped: true,\n      },\n    ],\n  })\n  return <Item model={character.items.at(0)} />\n}'} __scope={{props: this ? this.props : props,types,Character,Item}}>
  {() => {
    const character = Character.create({
      attributes: [
        { name: 'Strength' },
        { name: 'Charisma' },
      ],
      items: [{
        name: 'Greatsword of Maiming',
        description: 'The family sword of House Ednyzil.',
        effects: [
          { modifier: 2, modifies: 'Strength' },
          { modifier: 4, modifies: 'Charisma' },
          { modifier: 2, modifies: 'Charisma', condition: 'in Ft. Ednyzil' },
        ],
        equipped: true,
      }],
    })
return <Item model={character.items.at(0)} />
  }}
</Playground>
           </MDXTag>
  }
}
  